import { render, staticRenderFns } from "./IdeaScoreStartButton.vue?vue&type=template&id=39f0c6b9"
import script from "./IdeaScoreStartButton.vue?vue&type=script&lang=js"
export * from "./IdeaScoreStartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports